import * as React from "react";
const SvgFiRrInsightHead = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-insight-head_svg__a)">
      <path
        fill="#062147"
        d="M23.306 14.85a1 1 0 0 1-1.873-.7 9 9 0 0 0 .529-3.987c-.372-4.118-3.604-7.514-7.687-8.075-3.313-.452-6.479.867-8.475 3.53-1.343 1.662-3.719 6.576-3.802 7.407L3.205 13a1 1 0 0 1 .991.869l.334 2.524A3.01 3.01 0 0 0 7.505 19h1.494a1 1 0 0 1 1 1v1a1 1 0 0 0 1 1h7a1 1 0 0 0 .5-.134 1 1 0 1 1 1 1.732 3 3 0 0 1-1.5.4h-7c-1.654 0-3-1.345-3-3h-.494a5.015 5.015 0 0 1-4.957-4.343l-.219-1.656h-.33c-1.299 0-2-1.03-2-2 0-1.42 2.932-7.014 4.223-8.61C6.638 1.164 10.511-.443 14.547.105c4.996.688 8.952 4.84 9.407 9.877a11 11 0 0 1-.648 4.869m-1.599 3.443a.999.999 0 1 1-1.414 1.414l-3.822-3.822A5.96 5.96 0 0 1 13 17c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.69 6 6c0 1.294-.416 2.49-1.115 3.47zM13 15c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-insight-head_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrInsightHead;
